import React from 'react';
import {TabPanel, TabView} from "primereact/tabview";
import {Button} from "primereact/button";
import {Password} from "primereact/password";
import {InputText} from "primereact/inputtext";
import {Checkbox} from "primereact/checkbox";
import {InputTextarea} from "primereact/inputtextarea";

const Profile = () => {
    return (
        <div className='card relative'>
            <div style={{height:'200px',position:'absolute',zIndex:10}} className="top-0 left-0 w-full">
                <img style={{objectFit:'cover'}} src="https://www.metroparks.net/wp-content/uploads/2017/06/1080p_HBK_autumn-morning_GI.jpg" className={'h-full w-full'} alt=""/>
            </div>
            <div style={{height:'200px',zIndex:5}} className="relative"></div>
            <div className="grid align-items-end relative" style={{marginTop:'-100px',zIndex:15}}>
                <div className="col-2">
                    <div style={{height:'220px',width:'220px'}} className={'border-1 border-gray-200 p-1 bg-white'}>
                        <img style={{objectFit:'cover'}} className={'h-full w-full'} src="https://img.freepik.com/free-photo/closeup-young-hispanic-man-casuals-studio_662251-600.jpg?semt=ais_hybrid&w=740&q=80" alt=""/>
                    </div>
                </div>
                <div className="col-10">
                    <h4>Mr Sakhawat Hossain</h4>
                    <h6>Admin of Chemist Labratories</h6>
                    <ul className={'flex align-items-center gap-8 pl-3'}>
                        <li>Eskaton road, Dhaka 1208, Bangladesh</li>
                        <li>0195XX XXX XXX</li>
                        <li>chemist@info.com</li>
                    </ul>
                </div>
            </div>
            <div className="grid relative">
                <div className="col-2">
                    <div className="flex flex-column gap-3 p-4">
                        <div>
                            <div className="text-500 mb-1">Email</div>
                            <div className="font-medium">bipul@example.com</div>
                        </div>
                        <div>
                            <div className="text-500 mb-1">Phone</div>
                            <div className="font-medium">+880 1234-567890</div>
                        </div>
                        <div>
                            <div className="text-500 mb-1">Location</div>
                            <div className="font-medium">Dhaka, Bangladesh</div>
                        </div>
                    </div>
                    <div>
                        <img style={{objectFit:'cover'}} className={'h-full w-full'} src="https://upload.wikimedia.org/wikipedia/commons/d/d0/QR_code_for_mobile_English_Wikipedia.svg" alt=""/>
                    </div>
                    <h6 className="text-center mt-0">CH015A98D</h6>
                </div>
                <div className="col-10">
                    <div className="mt-5">
                        <TabView>
                            <TabPanel header="Profile Information">
                                <div className="border-1 border-200 border-round-xl p-4 bg-white">
                                    <div className="grid formgrid">
                                        <div className="col-12 md:col-6">
                                            <label htmlFor="firstName" className="block font-medium mb-2">First Name</label>
                                            <InputText id="firstName" value="Bipul" className="w-full" readOnly />
                                        </div>

                                        <div className="col-12 md:col-6">
                                            <label htmlFor="lastName" className="block font-medium mb-2">Last Name</label>
                                            <InputText id="lastName" value="Roy" className="w-full" readOnly />
                                        </div>

                                        <div className="col-12 md:col-6">
                                            <label htmlFor="email" className="block font-medium mb-2">Email Address</label>
                                            <InputText id="email" value="bipul@example.com" className="w-full" readOnly />
                                        </div>

                                        <div className="col-12 md:col-6">
                                            <label htmlFor="phone" className="block font-medium mb-2">Phone Number</label>
                                            <InputText id="phone" value="+880 1234-567890" className="w-full" readOnly />
                                        </div>

                                        <div className="col-12 md:col-6">
                                            <label htmlFor="company" className="block font-medium mb-2">Company</label>
                                            <InputText id="company" value="Premium Mart" className="w-full" readOnly />
                                        </div>

                                        <div className="col-12 md:col-6">
                                            <label htmlFor="role" className="block font-medium mb-2">Role</label>
                                            <InputText id="role" value="Product Designer" className="w-full" readOnly />
                                        </div>

                                        <div className="col-12">
                                            <label htmlFor="bio" className="block font-medium mb-2">Bio</label>
                                            <InputTextarea
                                                id="bio"
                                                rows={5}
                                                value="Passionate about creating clean, user-friendly digital experiences with modern interface design principles."
                                                className="w-full"
                                                readOnly
                                            />
                                        </div>

                                        <div className="col-12 md:col-6">
                                            <label htmlFor="website" className="block font-medium mb-2">Website</label>
                                            <InputText id="website" value="www.example.com" className="w-full" readOnly />
                                        </div>

                                        <div className="col-12 md:col-6">
                                            <label htmlFor="address" className="block font-medium mb-2">Address</label>
                                            <InputText id="address" value="Banani, Dhaka" className="w-full" readOnly />
                                        </div>
                                    </div>

                                    <div className="flex justify-content-end gap-2 mt-4">
                                        <Button type="button" label="Cancel" className="p-button-text" />
                                        <Button type="button" label="Edit Profile" icon="pi pi-pencil" />
                                    </div>
                                </div>
                            </TabPanel>
                            <TabPanel header="Password Change">
                                <form className="flex flex-column gap-4 w-6 border-1 border-200 border-round-xl p-4 bg-white">
                                    <div className="flex flex-column gap-2">
                                        <label htmlFor="email" className="font-medium">Email</label>
                                        <InputText
                                            id="email"
                                            placeholder="name@example.com"
                                            className={'w-full'}
                                        />
                                            <small className="p-error">Please enter a valid email address.</small>
                                    </div>

                                    <div className="flex flex-column gap-2">
                                        <label htmlFor="otp" className="font-medium">Verification Code</label>
                                        <InputText
                                            id="otp"
                                            placeholder="Enter code"
                                            keyfilter="int"
                                            maxLength={6}
                                            className={'w-full'}
                                        />
                                            <small className="p-error">Enter the 4 to 6 digit verification code.</small>
                                    </div>

                                    <div className="flex flex-column gap-2">
                                        <label htmlFor="newPassword" className="font-medium">New Password</label>
                                        <Password
                                            id="newPassword"
                                            placeholder="Create a strong password"
                                            toggleMask
                                            feedback={false}
                                            inputClassName="w-full"
                                            className={'w-full'}
                                        />
                                        <small className="text-600">
                                            Must be at least 8 characters and include uppercase, lowercase, and a number.
                                        </small>
                                            <small className="p-error">Password does not meet the required strength.</small>
                                    </div>

                                    <div className="flex flex-column gap-2">
                                        <label htmlFor="confirmPassword" className="font-medium">Confirm Password</label>
                                        <Password
                                            id="confirmPassword"
                                            // onChange={(e) => setConfirmPassword(e.target.value)}
                                            placeholder="Re-enter new password"
                                            toggleMask
                                            feedback={false}
                                            inputClassName="w-full"
                                            className={'w-full'}
                                        />
                                            <small className="p-error">Passwords do not match.</small>
                                    </div>

                                    <Button
                                        type="submit"
                                        label={'Reset Password'}
                                        icon="pi pi-lock-open"
                                        className="w-full"
                                    />
                                </form>
                            </TabPanel>
                            <TabPanel header="Account Deactivation">
                                <div className="w-6 border-1 border-200 border-round-xl p-4 bg-white">

                                    <div className="flex flex-column gap-4">
                                        <div className="p-3 border-1 border-round border-orange-200 bg-orange-50">
                                            <div className="font-semibold mb-2">Before you continue</div>
                                            <ul className="m-0 pl-3 text-700 line-height-3">
                                                <li>Your profile will be disabled.</li>
                                                <li>You may lose access to saved settings and history.</li>
                                                <li>This action may require support to reactivate your account.</li>
                                            </ul>
                                        </div>

                                        <div className="flex flex-column gap-2">
                                            <label htmlFor="reason" className="font-medium">Reason for deactivation</label>
                                            <InputTextarea
                                                id="reason"
                                                rows={5}
                                                placeholder="Tell us why you want to deactivate your account"
                                                className="w-full"
                                            />
                                        </div>

                                        <div className="flex align-items-start gap-2">
                                            <Checkbox inputId="confirm" checked={false} onChange={() => {}} />
                                            <label htmlFor="confirm" className="line-height-3 text-700">
                                                I understand the consequences of deactivating my account.
                                            </label>
                                        </div>

                                        <div className="flex justify-content-between gap-3 pt-2">
                                            <Button
                                                type="button"
                                                label="Cancel"
                                                className="p-button-outlined w-full"
                                            />
                                            <Button
                                                type="button"
                                                label="Deactivate Account"
                                                icon="pi pi-user-minus"
                                                severity="danger"
                                                className="w-full"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </TabPanel>
                        </TabView>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Profile;